import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableCreditApplication = loadable(
  () => import('./CreditApplication'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableCreditApplication;
